/* EBS — Wishlist + barre de recherche header (autonome). */
(function () {
  'use strict';

  var KEY = 'ebs_wishlist_v1';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  function r(path) { return (root.charAt(root.length - 1) === '/' ? root : root + '/') + path; }
  var WISHLIST_URL = r('pages/wishlist');

  var HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20s-7-4.4-9.3-8.4C1 8.5 2.4 5 5.7 5c2 0 3.3 1.2 4.3 2.6C11 6.2 12.3 5 14.3 5 17.6 5 19 8.5 17.3 11.6 15 15.6 12 20 12 20z"/></svg>';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function saveList(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} update(); document.dispatchEvent(new CustomEvent('ebs:wishlist:change')); }
  function has(h) { return read().some(function (x) { return x.handle === h; }); }
  function toggle(item) {
    var a = read();
    var i = a.findIndex(function (x) { return x.handle === item.handle; });
    var added;
    if (i > -1) { a.splice(i, 1); added = false; } else { a.unshift(item); added = true; }
    saveList(a);
    return added;
  }
  function count() { return read().length; }
  window.EBSWishlist = { read: read, has: has, toggle: toggle, count: count };

  function update() {
    var c = count();
    document.querySelectorAll('[data-ebs-wishlist-count]').forEach(function (el) {
      el.textContent = c;
      el.hidden = c === 0;
      var icon = el.closest('.ebs-wishlist-icon');
      if (icon) icon.classList.toggle('has-items', c > 0);
    });
    document.querySelectorAll('.ebs-card-heart, .ebs-pdp-heart').forEach(function (b) {
      b.classList.toggle('is-active', has(b.getAttribute('data-handle')));
    });
  }

  function handleFrom(href) { if (!href) return null; var m = href.match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }

  function injectHeaderHeart() {
    var host = document.querySelector('header-actions');
    if (!host || host.querySelector('.ebs-wishlist-link')) return;
    var a = document.createElement('a');
    a.href = WISHLIST_URL;
    a.className = 'header-actions__action ebs-wishlist-link';
    a.setAttribute('aria-label', 'Ma wishlist');
    a.innerHTML = '<span class="ebs-wishlist-icon">' + HEART + '<span class="ebs-wishlist-count" data-ebs-wishlist-count hidden>0</span></span>';
    var cart = host.querySelector('.action__cart') || host.querySelector('cart-drawer-component') || host.querySelector('[data-testid="cart-drawer-trigger"]') || host.lastElementChild;
    if (cart) host.insertBefore(a, cart); else host.appendChild(a);
  }

  function injectHeaderSearch() {
    var row = document.querySelector('.header__row--top') || document.querySelector('.header__row');
    if (!row || row.querySelector('.ebs-header-search')) return;
    var form = document.createElement('form');
    form.className = 'ebs-header-search';
    form.action = r('search');
    form.method = 'get';
    form.setAttribute('role', 'search');
    form.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>' +
      '<input type="search" name="q" placeholder="Rechercher un produit, une marque…" aria-label="Rechercher">' +
      '<input type="hidden" name="type" value="product">';
    row.appendChild(form);
  }

  function injectCardHearts() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (!a.querySelector('img')) return;
      if (a.closest('.cart-drawer, .cart-items, .ebs-cart-line, header, .header, .header-section, #ebs-wishlist-root, .ebs-wl-card, [data-ebs-no-heart]')) return;
      var container = a.closest('product-card, .product-card, .resource-card, .card-product, li.grid__item, [class*="card-product"]');
      if (!container || container.__ebsHeart) return;
      var handle = handleFrom(a.getAttribute('href'));
      if (!handle) return;
      container.__ebsHeart = true;
      if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ebs-card-heart' + (has(handle) ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Ajouter à ma wishlist');
      btn.setAttribute('data-handle', handle);
      btn.innerHTML = HEART;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var t = container.querySelector('.product-title, .card__heading, [class*="title"], [class*="Title"]');
        var img = container.querySelector('img');
        var added = toggle({ handle: handle, title: t ? t.textContent.trim() : '', image: img ? (img.currentSrc || img.src) : '' });
        btn.classList.toggle('is-active', added);
      });
      container.appendChild(btn);
    });
  }

  function injectProductPageHeart() {
    if (!/\/products\//.test(location.pathname)) return;
    var buttons = document.querySelector('.product-form-buttons');
    if (!buttons || buttons.querySelector('.ebs-pdp-heart')) return;
    var handle = handleFrom(location.pathname);
    if (!handle) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ebs-pdp-heart' + (has(handle) ? ' is-active' : '');
    btn.setAttribute('aria-label', 'Ajouter à ma wishlist');
    btn.setAttribute('data-handle', handle);
    btn.innerHTML = HEART;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var t = document.querySelector('.product-title, [class*="product"] h1, h1');
      var img = document.querySelector('.product-media img, [class*="gallery"] img, .product img, main img');
      var added = toggle({ handle: handle, title: t ? t.textContent.trim() : '', image: img ? (img.currentSrc || img.src) : '' });
      btn.classList.toggle('is-active', added);
    });
    var atc = buttons.querySelector('.add-to-cart-button') || buttons.querySelector('[ref="addToCartButton"]') || buttons.querySelector('button[name="add"]');
    var block = atc;
    while (block && block.parentElement && block.parentElement !== buttons) block = block.parentElement;
    if (!block || block.parentElement !== buttons) { buttons.appendChild(btn); return; }
    var wrap = document.createElement('div');
    wrap.className = 'ebs-atc-wrap';
    buttons.insertBefore(wrap, block);
    block.classList.add('ebs-atc-block');
    wrap.appendChild(block);
    wrap.appendChild(btn);
  }

  function addToCart(variantId, btn) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
    fetch(r('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
        if (trigger) trigger.click();
        else if (window.location.pathname.indexOf('/cart') === -1) window.location.href = r('cart');
        if (btn) { btn.disabled = false; btn.textContent = label; }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        window.location.href = r('cart');
      });
  }

  function money(cents) {
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CHF';
      return new Intl.NumberFormat('fr-CH', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' CHF'; }
  }

  function renderPage() {
    var rootEl = document.getElementById('ebs-wishlist-root');
    if (!rootEl) return;
    var items = read();
    if (!items.length) {
      rootEl.innerHTML =
        '<div class="ebs-wl-empty"><div class="ebs-wl-empty__icon">' + HEART + '</div>' +
        '<h2>Ta wishlist est vide</h2>' +
        '<p>Ajoute tes coups de cœur en cliquant sur le cœur ♡ affiché sur les produits.</p>' +
        '<a class="ebs-wl-empty__btn" href="' + r('collections/best-seller') + '">Découvrir les best-sellers</a></div>';
      return;
    }
    rootEl.innerHTML = '<div class="ebs-wl-grid"></div>';
    var grid = rootEl.querySelector('.ebs-wl-grid');
    items.forEach(function (it) {
      var url = r('products/' + it.handle);
      var card = document.createElement('div');
      card.className = 'ebs-wl-card';
      card.setAttribute('data-ebs-no-heart', '');
      card.innerHTML =
        '<a class="ebs-wl-card__media" href="' + url + '">' + (it.image ? '<img src="' + it.image + '" alt="">' : '') + '</a>' +
        '<a class="ebs-wl-card__title" href="' + url + '">' + (it.title || it.handle) + '</a>' +
        '<div class="ebs-wl-card__price"></div>' +
        '<div class="ebs-wl-card__actions"><button class="ebs-wl-remove" data-h="' + it.handle + '">Retirer</button>' +
        '<a class="ebs-wl-add" href="' + url + '">Voir le produit</a></div>';
      grid.appendChild(card);
      fetch(url + '.js').then(function (res) { return res.ok ? res.json() : null; }).then(function (p) {
        if (!p) return;
        var media = card.querySelector('.ebs-wl-card__media');
        var img = p.featured_image || (p.images && p.images[0]);
        if (img && !media.querySelector('img')) media.innerHTML = '<img src="' + img + '" alt="">';
        card.querySelector('.ebs-wl-card__title').textContent = p.title;
        card.querySelector('.ebs-wl-card__price').textContent = money(p.price);
        if (p.variants && p.variants.length === 1 && p.variants[0].available) {
          var link = card.querySelector('.ebs-wl-add');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ebs-wl-add';
          b.textContent = 'Ajouter au panier';
          b.addEventListener('click', function () { addToCart(p.variants[0].id, b); });
          link.replaceWith(b);
        }
      }).catch(function () {});
    });
    grid.addEventListener('click', function (e) {
      var b = e.target.closest('.ebs-wl-remove');
      if (!b) return;
      toggle({ handle: b.getAttribute('data-h') });
      renderPage();
    });
  }

  function run() { injectHeaderHeart(); injectHeaderSearch(); injectCardHearts(); injectProductPageHeart(); update(); }

  if (document.readyState !== 'loading') { run(); renderPage(); }
  else document.addEventListener('DOMContentLoaded', function () { run(); renderPage(); });

  document.addEventListener('ebs:wishlist:change', update);

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; injectHeaderHeart(); injectHeaderSearch(); injectCardHearts(); injectProductPageHeart(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
